/**
 * @generated SignedSource<<0462f29a9a0f99f29e119a1000e473f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SendMarketingEmailTestEmailDialog_marketingEmail$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "SendMarketingEmailTestEmailDialog_marketingEmail";
};
export type SendMarketingEmailTestEmailDialog_marketingEmail$key = {
  readonly " $data"?: SendMarketingEmailTestEmailDialog_marketingEmail$data;
  readonly " $fragmentSpreads": FragmentRefs<"SendMarketingEmailTestEmailDialog_marketingEmail">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SendMarketingEmailTestEmailDialog_marketingEmail",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "MarketingEmail",
  "abstractKey": null
};

(node as any).hash = "a2d0c9750bfc3900178f7b907b98416d";

export default node;
